module.exports = __webpack_public_path__ + "static/media/100.3df0fbfd.svg";